/**
 * Prevents the func function to be called more than once every <timeout> milliseconds
 * @param {Function} func
 * @param {Number} timeout
 * @returns
 */
export function debounce(func, timeout = defaultDebounceTimeout) {
  let timer;

  return function(...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export const defaultDebounceTimeout = 300;
